export default {
  200: '정상적으로 처리되었습니다.',
  401: '편집 권한이 없습니다. 관리자에게 문의해주세요.',
  402: '편집하려면 결제가 필요합니다.',
  403: '서버가 요청을 거부하였습니다. 권한이 없습니다.',
  404: '로그인에 실패하였습니다. 아이디와 비밀번호를 확인해주세요.',
  412: '검증이 되지 않았습니다.',
  500: '서버에 오류가 발생하여 요청을 수행할 수 없습니다.',
  501: '서버에 요청을 수행할 수 있는 기능이 없습니다.',
  502: '서버에서 잘못된 응답을 받았습니다.',
  503: '서비스가 현재 패치중입니다.',
  504: '서버 연결이 시간초과 되었습니다.',
  505: '서버가 요청에 사용된 HTTP 프로토콜 버전을 지원하지 않습니다.',
};



// WEBPACK FOOTER //
// ./src/vuex/handler/messages/service-messages.js